import { ReactNode, useCallback, useEffect, useRef } from 'react';
import styles from './Toast.module.scss';

interface ToastProps {
  id: string;
  content: ReactNode;
  type?: 'success' | 'error' | 'info' | 'warning';
  onClose: (id: string) => void;
}

const Toast = ({ id, content, type, onClose }: ToastProps) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const startTimer = useCallback(() => {
    timerRef.current = setTimeout(() => onClose(id), 3000); // Auto-dismiss after 3 seconds
  }, [id, onClose]);

  const clearTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  useEffect(() => {
    startTimer(); // Start timer when component mounts
    return clearTimer; // Clear timer if component unmounts
  }, [startTimer, clearTimer]);

  return (
    <div
      className={`${styles.toast} ${type ? styles[type] : ''}`}
      onMouseEnter={clearTimer} // Pause timer
      onMouseLeave={startTimer} // Resume timer
      onClick={() => onClose(id)} // Immediate dismissal on click
    >
      {content}
    </div>
  );
};

export default Toast;
